const DEVICE_UUID_STORAGE_KEY = "attendanceDeviceUuid";

const createDeviceUuid = () => {
    const randomPart = () => Math.random().toString(16).slice(2, 10);

    return `web-${ randomPart() }-${ randomPart() }`;
};

const getStorageItem = (key) => {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
};

const setStorageItem = (key, value) => {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {
        return false;
    }

    return true;
};

export const getAttendanceDeviceUuid = () => {
    const existingUuid = getStorageItem(DEVICE_UUID_STORAGE_KEY);

    if (existingUuid) {
        return existingUuid;
    }

    const nextUuid = createDeviceUuid();

    setStorageItem(DEVICE_UUID_STORAGE_KEY, nextUuid);

    return nextUuid;
};

export const getAttendancePlatform = () => {
    const userAgent = window.navigator?.userAgent || "";
    const platform = window.navigator?.userAgentData?.platform || window.navigator?.platform || "";
    const platformText = `${ platform } ${ userAgent }`.toLowerCase();

    if (platformText.includes("android")) {
        return "android";
    }

    if (
        platformText.includes("iphone") ||
        platformText.includes("ipad") ||
        platformText.includes("ipod")
    ) {
        return "ios";
    }

    return "web";
};

export const getAttendanceDeviceData = () => ({
    device_uuid: getAttendanceDeviceUuid(),
    platform: getAttendancePlatform(),
    user_agent: window.navigator?.userAgent || ""
});
